import { z } from "zod";

export const raw16Schema = z.string().regex(/^[0-9a-f]{32}$/u);

export const cleanerInvitationStatusSchema = z.enum([
  "QUEUED",
  "SENT",
  "ACCEPTED",
  "DECLINED",
  "RESCINDED",
  "EXPIRED",
  "CANCELLED",
]);

const timestampSchema = z.string().datetime({ offset: true });
const nullableTimestampSchema = timestampSchema.nullable();

export const cleanerInvitationSchema = z.strictObject({
  invitationId: raw16Schema,
  jobId: raw16Schema,
  propertyId: raw16Schema,
  cleanerUserId: raw16Schema,
  rankNo: z.number().int().min(1).max(20),
  status: cleanerInvitationStatusSchema,
  sentAt: nullableTimestampSchema,
  respondedAt: nullableTimestampSchema,
  resolvedAt: nullableTimestampSchema,
  createdAt: timestampSchema,
  publicName: z.string().nullable(),
});

export const cleanerInvitationListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  invitations: z.array(cleanerInvitationSchema),
});

export const cleanerInvitationInboxEntrySchema = z.strictObject({
  invitationId: raw16Schema,
  jobId: raw16Schema,
  propertyId: raw16Schema,
  rankNo: z.number().int().min(1).max(20),
  status: cleanerInvitationStatusSchema,
  sentAt: nullableTimestampSchema,
  respondedAt: nullableTimestampSchema,
  resolvedAt: nullableTimestampSchema,
  createdAt: timestampSchema,
  jobNumber: z.string(),
  cleaningType: z.string(),
  requestStartAt: timestampSchema,
  requestEndAt: timestampSchema,
  timezoneRegion: z.string(),
});

export const cleanerInvitationInboxResponseSchema = z.strictObject({
  status: z.literal("ok"),
  invitations: z.array(cleanerInvitationInboxEntrySchema),
});

export const cleanerInvitationDispatchResponseSchema = z.strictObject({
  status: z.literal("dispatched"),
  invitationCount: z.number().int().min(1).max(20),
});

export const cleanerInvitationChangedResponseSchema = z.strictObject({
  status: z.enum(["changed", "unchanged"]),
  jobId: raw16Schema.nullable(),
});

export type CleanerInvitation = z.infer<typeof cleanerInvitationSchema>;
export type CleanerInvitationInboxEntry = z.infer<typeof cleanerInvitationInboxEntrySchema>;
export type CleanerInvitationStatus = z.infer<typeof cleanerInvitationStatusSchema>;
